import React from 'react';

import {DashboardWidget} from 'app/components/Dashboard/DashboardWidget';
import cs from 'app/components/Dashboard/MultiFeatureAnalysisWidget/MultiFeatureAnalysisSkeleton.module.scss';

export const MultiFeatureAnalysisSkeleton: React.FC<{
  size?: 'small' | 'large';
}> = ({size = 'small'}) => {
  return (
    <DashboardWidget title={<span className="bp5-skeleton">Loading Analysis</span>} size={size}>
      <div className={cs.skeletonLoader} />
    </DashboardWidget>
  );
};
